import type { SITE_PILOTS_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-pilots-table/site-pilots-table.fr.ts";

export const SITE_PILOTS_TABLE_ENGLISH_LOCALE = {
  headers: {
    serialNumber: "Serial number",
    csId: "Cs Id",
    hwId: "Hardware Id",
    operator: "Operator",
    lastConnectionDate: "Last connection",
    softwareVersion: "Software version",
    installationDate: "Installation date",
  },
  empty: "No pilot found...",
} satisfies typeof SITE_PILOTS_TABLE_FRENCH_LOCALE;
